
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActionSheetController, AlertController, IonContent, IonList, IonTextarea, ModalController, NavController } from '@ionic/angular';
import { Conversation } from 'src/app/Models/Classes/Chat/conversation';
import { Message } from 'src/app/Models/Classes/Chat/message';
import { MediaItem } from 'src/app/Models/Classes/Media/media-item';
import { Utils } from 'src/app/Models/Classes/utils';
import { ChatService } from 'src/app/services/chat/chat.service';
import { CameraServiceService } from 'src/app/services/multimedia/camera-service.service';
import { InputAlertControllerService } from 'src/app/services/utils/input-alert-controller.service';
import { CheckUsersListComponent } from '../check-users-list/check-users-list.component';
import Swal2 from "sweetalert2";
import * as models from "../../../Models/Classes/graphql/models/models-graphql";
import {CommentsService} from "../../../services/comments/comments.service";
import {UploadMultimediaService} from "../../../services/upload/upload-multimedia.service";
import {MultimediaInChatService} from "../../../services/chat/multimedia-in-chat.service";
import { RequestService } from 'src/app/services/request/request.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { Capacitor } from '@capacitor/core';
import { Contacts } from '@capacitor-community/contacts';
import { FormServiceService } from 'src/app/services/publications/form-service.service';
@Component({
	selector: 'app-messages-list',
	templateUrl: './messages-list.component.html',
	styleUrls: ['./messages-list.component.scss'],
})
export class MessagesListComponent implements OnInit {

	@Input() username: any;
	@Input() pageMode: boolean = false;
	@ViewChild(IonContent) contentArea: IonContent;
	@ViewChild('chatFileInput') chatFileInput?: ElementRef<HTMLInputElement>;
	@ViewChild(IonList, { read: ElementRef }) set chatList(el: ElementRef) {
		this.mutationObserver.observe(el.nativeElement, {
			childList: true
		});
	};
	@Input() conversation: Conversation;
	@Output() domChange = new EventEmitter<any>();
public objmedia: any;
public newMessage: Message;
@Input() send_ai_message;
public messageResponse: Message;
  public answering: boolean = false;
	public conversationAvatar = 'assets/icon/usuario.png';
	public showScrollButton: boolean = false;
	public chat_imagen: string;
	public offsetTop: number = 0;
	public timing: number = 0;
	private mutationObserver: MutationObserver;
	constructor(
		private chatService: ChatService,
		private cameraService: CameraServiceService,
		private inputAlertController: InputAlertControllerService,
		private utils: Utils,
		private modalController: ModalController,
		private navCtrl: NavController,
    private commentService: CommentsService,
    private uploadMultimediaService: UploadMultimediaService,
    private chatElementService: MultimediaInChatService,
	private request: RequestService,
	private profileService: ProfileService,
	public formservice: FormServiceService,
	private alertController: AlertController,
	private actionSheetController: ActionSheetController,
	) {
		this.newMessage = new Message();

		this.mutationObserver = new MutationObserver((mutations: MutationRecord[]) => {
			mutations.forEach((mutation: any) => {
				if (this.offsetTop < mutation.target.offsetHeight) {
					this.offsetTop = mutation.target.offsetHeight;
				}
				if (this.offsetTop == mutation.addedNodes[0].offsetTop + 18) {
					if (this.conversation.getLastMessage().getMultimediaID() != null || (this.conversation.getLastMessage().getMessageResponse() && this.conversation.getLastMessage().getMessageResponse().getMultimediaID() != null)) {

						setTimeout(() => {
							this.contentArea.scrollToBottom();
						}, 400);
					} else {

						setTimeout(() => {
							this.contentArea.scrollToBottom();
						}, 50);
					}
				}
			});
		});
	}
	startVideoCall(){
		this.openCallPage(true);
	}
	startCall(){
		this.openCallPage(false);
	}

	private openCallPage(videoCall: boolean): void {
		this.formservice.webViewLive = false;
		void this.navCtrl.navigateForward('/chime-contact', {
			queryParams: {
				chat_call: 'true',
				username: this.username,
				recipient_username: this.conversation.getUsers()[0].username,
				recipient_user_id: this.conversation.getUsers()[0].id,
				conversationID: this.conversation.getID(),
				...(videoCall ? { videoCall: 'true' } : { call: 'true' }),
			},
		});
	}
	
	ngOnInit() {
		this.loadConversationAvatar();
		this.conversation.getMessagesList().forEach((message) => {
			if (message.getMultimediaID() != null) {
				this.timing = 500;
			}
		});
	}

	private loadConversationAvatar(): void {
		if (this.conversation?.getIsGroup()) {
			this.conversationAvatar = this.conversation.getGroupImage() || this.conversationAvatar;
			return;
		}

		const userId = this.conversation?.getUsers?.()[0]?.id;
		if (!userId) return;
		// `User` in the Chat schema only contains the signup-time snapshot.
		// The profile endpoint is backed by the profile API/Lambda and returns
		// the current RDS profile photo for this exact user ID.
		this.profileService.getProfileInfo(Number(userId)).then((raw) => {
			let profile = raw;
			if (typeof profile === 'string') profile = JSON.parse(profile);
			const photo = profile?.profile_photo?.url
				|| profile?.profile_photo?.route
				|| profile?.profile_photo;
			const url = this.resolveProfilePhoto(photo);
			if (url) this.conversationAvatar = url;
		}).catch((error) => {
			console.warn('Unable to load the current profile avatar for this conversation.', error);
		});
	}

	private resolveProfilePhoto(photo: any): string | null {
		const value = typeof photo === 'string' ? photo.trim() : '';
		if (!value) return null;
		if (/^(https?:|data:|blob:|capacitor:)/i.test(value)) return value;
		return `https://laniakea-multimedia.s3.amazonaws.com/${value.replace(/^\/+/, '')}`;
	}

	onConversationAvatarError(event: Event): void {
		const image = event.target as HTMLImageElement;
		if (image && !image.src.endsWith('/assets/icon/usuario.png')) {
			image.src = 'assets/icon/usuario.png';
		}
	}

	onDomChange(event) {
		console.log(event);
	}

	ngAfterViewInit() {
if(this.send_ai_message){
	this.setMessage(this.send_ai_message);
	this.clickOnSend();
	this.send_ai_message=null;
}
		if (this.timing != 0) {
			setTimeout(() => {
				this.contentArea.scrollToBottom();
			}, this.timing);
		} else {
			setTimeout(() => {
				this.contentArea.scrollToBottom();
			}, this.conversation.getMessagesList().length * 3);
		}
		this.chatService.updateSeenMessages(this.conversation);
		this.chatService.conversationOpened = this.conversation.getID();
	}

	public setMessage(message: string) {
		this.newMessage.setText(message ?? '');
	}

	public clickOnSend(message?: string) {
		if (message !== undefined) {
			this.setMessage(message);
		}
    if (this.commentService.blobsMultimediaComment.length > 0 || !this.IsEmptyText(this.newMessage.getText())) {
		Swal2.fire({
			title: 'Procesando...',
			text: 'The message is being processed.',
			icon: 'success',
			timer: 4000, // Show the alert for 4 seconds
			background: '#010f4e',
			position: 'top-end',
			timerProgressBar: true,
			toast: true,
			showConfirmButton: false
		  });
		this.post();
    }
	}

	async openAttachmentMenu(): Promise<void> {
		const sheet = await this.actionSheetController.create({
			header: 'Share in chat',
			cssClass: 'chat-attachment-sheet',
			buttons: [
				{ text: 'File', icon: 'document-attach-outline', handler: () => this.shareFile() },
				{ text: 'Location', icon: 'location-outline', handler: () => this.chooseLocationShare() },
				{ text: 'Contact', icon: 'person-circle-outline', handler: () => this.shareConversationContact() },
				{ text: 'Poll', icon: 'bar-chart-outline', handler: () => this.createPoll() },
				{ text: 'Event', icon: 'calendar-outline', handler: () => this.createEvent() },
				{ text: 'Cancel', icon: 'close-outline', role: 'cancel' },
			],
		});
		await sheet.present();
	}

	private sendRich(type: string, payload: any, fallback: string): void {
		// Rich cards are text payloads. Never let a previously failed attachment
		// leak into a contact, poll, location, or event message.
		this.commentService.blobsMultimediaComment = [];
		this.newMessage.setText(`[[LK_RICH]]${JSON.stringify({ type, payload, fallback })}`);
		this.clickOnSend();
	}

	private shareLocation(): void {
		if (!navigator.geolocation) return;
		navigator.geolocation.getCurrentPosition(position => this.sendRich('location', {
			latitude: position.coords.latitude, longitude: position.coords.longitude,
		}, 'Shared a location'), () => undefined, { enableHighAccuracy: true, timeout: 10000 });
	}

	private async chooseLocationShare(): Promise<void> {
		const sheet = await this.actionSheetController.create({ header: 'Share location', buttons: [
			{ text: 'Send current location', icon: 'location-outline', handler: () => this.shareLocation() },
			{ text: 'Share live location for 15 minutes', icon: 'navigate-outline', handler: () => this.shareLiveLocation(15) },
			{ text: 'Share live location for 1 hour', icon: 'navigate-outline', handler: () => this.shareLiveLocation(60) },
			{ text: 'Cancel', role: 'cancel' },
		] });
		await sheet.present();
	}

	private shareLiveLocation(minutes: number): void {
		if (!navigator.geolocation) return;
		navigator.geolocation.getCurrentPosition(position => this.sendRich('live_location', {
			latitude: position.coords.latitude, longitude: position.coords.longitude,
			expires_at: new Date(Date.now() + minutes * 60_000).toISOString(), minutes,
		}, `Sharing live location for ${minutes} minutes`), () => undefined, { enableHighAccuracy: true, timeout: 10000 });
	}

	shareFile(): void {
		this.chatFileInput?.nativeElement.click();
	}

	onFileSelected(event: Event): void {
		const file = (event.target as HTMLInputElement).files?.[0];
		if (!file) return;
		this.commentService.blobsMultimediaComment = [{ blob: file, filename: file.name }];
		this.newMessage.setText(`📎 ${file.name}`);
		this.clickOnSend();
		(event.target as HTMLInputElement).value = '';
	}

	private async shareConversationContact(): Promise<void> {
		if (Capacitor.isNativePlatform()) {
			try {
				let permission = await Contacts.checkPermissions();
				if (permission.contacts !== 'granted') permission = await Contacts.requestPermissions();
				if (permission.contacts === 'granted') {
					const result = await Contacts.getContacts({ projection: { name: true, phones: true, emails: true } });
					const contacts = (result.contacts || []).slice(0, 50);
					const picker = await this.alertController.create({ header: 'Select a contact', inputs: contacts.map((contact: any, index: number) => ({
						type: 'radio', name: String(index), value: index, label: contact.name?.display || contact.phones?.[0]?.number || 'Contact',
					})), buttons: [{ text: 'Cancel', role: 'cancel' }, { text: 'Share', handler: index => {
						const contact: any = contacts[index];
						if (contact) this.sendRich('contact', { name: contact.name?.display || 'Contact', phone: contact.phones?.[0]?.number || '', email: contact.emails?.[0]?.address || '' }, `Shared contact: ${contact.name?.display || 'Contact'}`);
					}}] });
					await picker.present();
					return;
				}
			} catch (error) { console.warn('Unable to read device contacts', error); }
		}
		const contact = this.conversation.getUsers?.()[0];
		if (!contact) return;
		this.sendRich('contact', { user_id: contact.id, username: contact.username }, `Shared contact: @${contact.username}`);
	}

	private async createPoll(): Promise<void> {
		const alert = await this.alertController.create({ header: 'Create poll', inputs: [
			{ name: 'question', placeholder: 'Question' }, { name: 'option1', placeholder: 'Option 1' }, { name: 'option2', placeholder: 'Option 2' },
		], buttons: [{ text: 'Cancel', role: 'cancel' }, { text: 'Send', handler: value => {
			const options = [value.option1, value.option2].filter(Boolean);
			if (value.question && options.length >= 2) this.sendRich('poll', { question: value.question, options, votes: {} }, `Poll: ${value.question}`);
		}}] });
		await alert.present();
	}

	private async createEvent(): Promise<void> {
		const alert = await this.alertController.create({ header: 'Share event', inputs: [
			{ name: 'title', placeholder: 'Event title' }, { name: 'starts_at', placeholder: 'Date and time' }, { name: 'location', placeholder: 'Location or meeting link' },
		], buttons: [{ text: 'Cancel', role: 'cancel' }, { text: 'Send', handler: value => {
			if (value.title) this.sendRich('event', value, `Event: ${value.title}`);
		}}] });
		await alert.present();
	}

  private IsEmptyText(textInput: string | null | undefined) {
	textInput = textInput ?? '';
    textInput = textInput.replace(/[\r\n\s]+/gm, "");
    if (textInput.length > 0) {
      return false;
    }
    else {
      return true;
    }
  }

  takePhoto() {
    this.cameraService.takePhoto().then((mediaItem) => {
      this.newMessage.setMultimedia(mediaItem);
    }).catch((error) => {
      console.error(error);
    });
  }

  pickMedia() {
    this.cameraService.pickMedia().then((mediaItem) => {
      this.newMessage.setMultimedia(mediaItem);
    }).catch((error) => {
      console.error(error);
    });
  }

  takeVideo() {
    this.cameraService.takeVideo().then((mediaItem) => {
      this.newMessage.setMultimedia(mediaItem);
    }).catch((error) => {
      console.error(error);
    });
  }

	public moreData(event?) {
		if (!this.conversation.getNextToken()) {
			event.target.complete();
			event.target.disabled = true;
		} else {

			this.chatService.getMessagesByConversation(this.conversation, 10, this.conversation.getNextToken()).then(() => {
				event.target.complete();
			}).catch((error) => {
				event.target.complete();
				console.error(error);
			});
		}
	}

  public post() {

	
		const notification = {
			user_id: this.formservice.profile.id,
		
		};
	
		this.request.createRequestPost('validateThatTheUserIsUnblockedInMessage', notification)
		  .then((data) => {

			if (data && typeof data === 'string') {
				try {
					data = JSON.parse(data);
				  console.log('getRecordByToken ios:',data);
				} catch (error) {
				  console.error("Error parsing data:", error);
				}
				}
	  console.log('posting the message');
    let tempMessage = this.newMessage;
    let tempMessageResponse = this.messageResponse;
    this.newMessage = new Message();
    this.utils.loadingPresent().then(() => {
      let newMessageReq: models.CreateMessageInput = {
        userID: this.chatService.owner.id,
        conversationID: this.conversation.getID(),
        isDelete: false,
        isSeen: false,
        isSystemNotification: false,
        body: tempMessage.getText()
      };
      if (tempMessageResponse) {
        newMessageReq.messageID = tempMessageResponse.getId();
      }
      if (this.commentService.blobsMultimediaComment.length>0) {
        this.commentService.blobsMultimediaComment.forEach(element => {
          console.log('media item in chat service', element);
          this.uploadMultimediaService.post(element.blob, element.filename).then(({ link, mimeType }) => {
			const ruta = link;
		   // const ruta = r[0];
			//const mimeType = r[1];
			console.log('ruta', ruta);
	            const normalizedMimeType = String(mimeType || element.blob?.type || '').toLowerCase();
	            const pub_type = normalizedMimeType.includes('pdf') ? 'pdf'
				: normalizedMimeType.includes('audio') ? 'audio'
				: normalizedMimeType.includes('video') ? 'video'
				: 'imagen';
			if (pub_type === 'pdf') {
				// Documents do not need the legacy Cordova-backed chatElement API.
				// Send a portable file card after the S3 upload instead.
				newMessageReq.body = `[[LK_RICH]]${JSON.stringify({
					type: 'file', payload: { name: element.filename, url: ruta, mime_type: normalizedMimeType },
					fallback: `File: ${element.filename}`,
				})}`;
				this.chatService.sendMessageOnGraphQl(newMessageReq).then(() => {
					this.notifyConversationRecipient(tempMessage);
					this.commentService.blobsMultimediaComment = [];
					this.utils.loadingDismiss();
				}).catch(error => {
					console.error(error);
					this.commentService.blobsMultimediaComment = [];
					this.utils.loadingDismiss();
				});
				return;
			}
            //let objmedia;
            const element_type = 'mensaje';
            this.objmedia = {
              route: ruta,
              size: 800,
              type: pub_type,
              element_type
            };
	            this.chatElementService.postChatElement(this.objmedia).then((data: any) => {
				  const chatElementResponse = typeof data === 'string' ? JSON.parse(data) : data;
	              const chatElement_id = chatElementResponse.chat_element_id;
	              const status = {status: 'activa'};
	              this.chatElementService.putChatElement(status, chatElement_id).then((result: any) => {
	                //this.presentToastWithOptions();
					const d = typeof result === 'string' ? JSON.parse(result) : result;
                newMessageReq.multimediaID = d.chatElement.id;
                this.chatService.sendMessageOnGraphQl(newMessageReq).then((messageResponse) => {
				  this.notifyConversationRecipient(tempMessage);
                  this.utils.loadingDismiss();
                  this.commentService.blobsMultimediaComment = [];
                  this.newMessage.deleteMultimedia(0);
                  this.answering = false;
                  this.messageResponse = undefined;
				}).catch((error) => {
				  console.error(error);
				  this.commentService.blobsMultimediaComment = [];
				  this.utils.loadingDismiss();
				});
	              }).catch((error) => {
	                console.error(error);
					this.commentService.blobsMultimediaComment = [];
	                this.utils.loadingDismiss();
	              });
	            }).catch((error) => {
	              console.error(error);
				  this.commentService.blobsMultimediaComment = [];
	              this.utils.loadingDismiss();
            });
          });
        });
      }else {
        this.chatService.sendMessageOnGraphQl(newMessageReq).then((messageResponse) => {
		  this.notifyConversationRecipient(tempMessage);
          this.answering = false;
          this.messageResponse = undefined;
          this.utils.loadingDismiss();
        }).catch((error) => {
          console.error(error);
          this.utils.loadingDismiss();
        });
      }


    });
}).catch((error) => {
	console.error('The user might be indeed blocked:', error);
	Swal2.fire({
		title: 'Mensaje bloqueado',
		text: 'Es probable que tú o el usuario se hayan bloqueado',
		icon: 'error',
		confirmButtonText: 'Understood',
		color: '#ffffff',
		background: '#010f4e',
		position: 'top-end',
		timerProgressBar: true,
		toast: true,
	  });
  });
  }

	public checkScroller(event?) {
		this.contentArea.getScrollElement().then((data) => {
			let maxScroll = data['scrollHeight'];
			let difference = data['scrollTop'] + data['clientHeight'];

			if ((maxScroll - difference) < 5) {
				this.showScrollButton = false;
			}
			else {
				this.showScrollButton = true;
			}
		}).catch((error) => {
			console.error(error);
		});
	}

	public scrollToBottom() {
		this.contentArea.scrollToBottom();
	}

	public presentActionSheet() {
		let buttons = new Array<any>();

		if (this.conversation.getIsGroup()) {
			//buttons.push({ text: 'Salir del grupo', icon: 'log-out' });
			buttons.push({ text: 'Cambiar imagen de la conversación', icon: 'images' });
			buttons.push({ text: 'Cambiar nombre de la conversación', icon: 'text' });
		}
		else {
			//buttons.push({ text: 'Eliminar todos los mensajes', icon: 'trash' });
			buttons.push({ text: 'Ver perfil del usuario', icon: 'person-circle' });
		}
		this.inputAlertController.SelectorActionSheet(buttons, "Opciones de conversacion").then((result) => {

			if (result['action']) {
				switch (result['button']['text']) {
					case 'Salir del grupo': {
						this.inputAlertController.OkInfoMessage(
							"Función en desarrollo", 												//Header
							"Estamos trabajando para que puedas usar esta función lo antes posible",//Message
							"Esperar una versión futura"											//Ok Button Text
						);
						break;
					}
					case 'Cambiar imagen de la conversación': {
						this.changeChatImage();
						break;
					}
					case 'Cambiar nombre de la conversación': {
						this.updateConversationName();
						break;
					}
					case 'Eliminar todos los mensajes': {
						this.inputAlertController.OkInfoMessage(
							"Función en desarrollo", 												//Header
							"Estamos trabajando para que puedas usar esta función lo antes posible",//Message
							"Esperar una versión futura"											//Ok Button Text
						);
						break;
					}
					case 'Ver perfil del usuario': {
						this.utils.loadingPresent().then(() => {
							this.modalController.dismiss().then(() => {
								this.utils.loadingDismiss().then(() => {
									this.navCtrl.navigateForward('home/profile/' + this.conversation.getUsers()[0].id);
								});
							}).catch(() => {
								this.utils.loadingDismiss();
							});
						});


						break;
					}
					default: break;
				}
			}
		}).catch((error) => {
			console.error(error);
		});
	}

	public changeChatImage() {
		this.cameraService.askForMediCapture(true, false, true).then((value) => {
			switch (value) {
				case "Imagen":
					this.cameraService.takePhoto().then((mediaItem: MediaItem) => {
						this.chatService.uploadChatImagen(mediaItem, this.conversation).then((chatElementResponse) => {
							this.conversation.setGroupImage(chatElementResponse.chatElement.media.url);
							this.conversation.setMultimediaID(chatElementResponse.chatElement.id);
						}).catch((error) => {
							console.error(error);
						});
					}).catch((error) => {
						console.error(error);
					});
					break;
				case "Pick":
					this.cameraService.pickMedia("Imagen").then((mediaItem) => {
						this.chatService.uploadChatImagen(mediaItem, this.conversation).then((chatElementResponse) => {
							this.conversation.setGroupImage(chatElementResponse.chatElement.media.url);
							this.conversation.setMultimediaID(chatElementResponse.chatElement.id);
						}).catch((error) => {
							console.error(error);
						});
					}).catch((error) => {
						console.error(error);
					});
					break;
				default:
					break;
			}
		}).catch((error) => {
			console.error(error);
		});
	}

	public updateConversationName() {
		this.inputAlertController.InputAlertPrompt(
			"Modificar nombre del grupo", 								//Header
			"Ingresa el nuevo nombre",									//Message
			this.conversation.getName(), 								//Input Value
			"text", 													//Input Type
			"Cambiar Nombre",											//Ok Button Text
			"20"														//Max Length
		).then((result) => {
			if (result['action']) {
				this.conversation.setName(result['value']);
				this.chatService.updateConversationName(this.conversation).then((promisesArray) => {
					console.log(promisesArray);
				}).catch((error) => {
					console.error(error);
				});
			}

		}).catch((error) => {
			console.error(error);
		});
	}

	public setMessageResponse(event?: any) {
		this.messageResponse = event.message;
    this.answering = true;
	}

	public openResendModal(event?: any) {
		this.modalController.create({
			component: CheckUsersListComponent,
			cssClass: 'detailsInModal',
			canDismiss: true, // canDismiss enables swipe-to-close (patch forces on ALL ModalController creates)
			componentProps: {
				resendMesage: event.message
			}
		}).then((modal) => {
			modal.present();
		});
	}

	public deleteMessage(event?: any) {
		this.chatService.updateMessage(event.message).then((messageResponse) => {
			console.log(messageResponse)
		}).catch((error) => {
			console.error(error);
		});
	}

	public deleteMedia(event) { }

	/**
	 * This component sends messages straight to GraphQL, so it must trigger the
	 * remote push once that mutation succeeds. Chat IDs are profile IDs; the API
	 * resolves the matching RDS user/token from that ID server-side.
	 */
	private notifyConversationRecipient(message: Message): void {
		const senderProfileId = String(this.chatService.owner?.id || '');
		const recipient = (this.conversation.getUsers() || []).find((user) =>
			String(user?.id || '') !== senderProfileId,
		);
		const recipientProfileId = Number(recipient?.id || 0);
		if (!recipientProfileId) {
			console.warn('Direct-message push skipped: recipient profile was not found.');
			return;
		}

		this.chatService.sendNotification(
			recipientProfileId,
			message.getText() || 'Te envió un archivo multimedia.',
			`Nuevo mensaje de @${this.chatService.owner?.username || 'Laniakea'}`,
			this.conversation.getID(),
		).catch((error) => console.error('Failed to send direct-message push notification:', error));
	}
}
